/**
 * Module dependencies.
 */

import { TourData } from 'src/types/tour';
import { forwardRef } from 'react';
import { media } from 'src/styles/media';
import Biography from 'src/components/sections/episode/guest-section/biography';
import Container from 'src/components/core/layout/container';
import Intro from 'src/components/sections/episode/guest-section/intro';
import IntroGuest from 'src/components/sections/episode/guest-section/intro-guest';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = TourData['sections']['guest'];

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  padding-top: 7.188rem;
  position: relative;

  ${media.min.md`
    background-color: var(--color-grey-100);
    padding: 0;
  `}
`;

/**
 * `ContainerStyle` styled component.
 */

const ContainerStyle = styled(Container)`
  padding: 0;

  ${media.min.md`
    align-items: center;
    display: flex;
    height: 100vh;
  `}
`;

/**
 * `GuestSection` component.
 */

const GuestSection = forwardRef<HTMLDivElement, Props>(
  ({ assets, author, biography, continueText, ...rest }, ref) => (
    <Wrapper ref={ref}>
      <ContainerStyle fluid>
        <IntroGuest {...{ assets, author, ...rest }} />

        <Intro {...{ assets, author, ...rest }} />

        <Biography {...{ assets, author, biography, continueText }} />
      </ContainerStyle>
    </Wrapper>
  )
);

GuestSection.displayName = 'GuestSection';

/**
 * Export `GuestSection` component.
 */

export default GuestSection;
